const auth = {
  login: 'Đăng nhập',
  error: 'Xảy ra lỗi'
};

export default auth;
